import React from 'react';
import CountUp from 'react-countup';

const FunFact = (props) => {
  return (
    <section className={'' + props.hclass}>
      <div className='container'>
        <div className='titel-image'>
          <h1>Logistics</h1>
          <h3>
            Smart shipping solutions for road, air, ocean, and warehousing needs
          </h3>
        </div>

        <div className='row'>
          <div className='col-lg-3 col-md-6 col-12'>
            <div className='item'>
              <h2>
                <CountUp end={100} enableScrollSpy />+
              </h2>
              <h3>Cities Connected</h3>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-12'>
            <div className='item'>
              <h2>
                <CountUp end={11} enableScrollSpy />.
                <CountUp end={6} enableScrollSpy />K
              </h2>
              <h3>Goods Delivered Weekly</h3>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-12'>
            <div className='item'>
              <h2>
                <CountUp end={4} enableScrollSpy />+
              </h2>
              <h3>Core Logistics Services</h3>
            </div>
          </div>

          <div className='col-lg-3 col-md-6 col-12'>
            <div className='item'>
              <h2>
                <CountUp end={95} enableScrollSpy />%
              </h2>
              <h3>Client Satisfaction</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;
